import { render, staticRenderFns } from "./AutomationIcon.vue?vue&type=template&id=40456f28&scoped=true"
import script from "./AutomationIcon.vue?vue&type=script&lang=js"
export * from "./AutomationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40456f28",
  null
  
)

export default component.exports